// https://onyxpayments.atlassian.net/wiki/spaces/PION/pages/35160086/Payment+Statuses

export enum UISearchTypeMappingEnum {
  HAS_PREPAYMENT = <any>'pre',
  FINAL = <any>'final'
}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/ui-search-type-mapping-enum.ts